export const isMarketLoaded = (marketId, marketsData) =>
  marketsData[marketId] != null && marketsData[marketId].description != null;
